// ---------------------------------------------------------------------------
// PWA Caisse Tablette — Table info card (details + action buttons)
// ---------------------------------------------------------------------------

import type { Table } from '@/lib/types';

interface TableInfoCardProps {
  table: Table;
  onLock: () => void;
  onRelease: () => void;
  onInstantReservation: () => void;
  onTransfer: () => void;
  onAssociateToCart?: () => void;
}

const STATE_LABELS: Record<string, string> = {
  libre: 'Libre',
  reservee: 'Reservee',
  occupee: 'Occupee',
  verrouillee: 'Verrouillee',
};

const STATE_BADGE: Record<string, string> = {
  libre: 'bg-table-libre/20 text-table-libre',
  reservee: 'bg-table-reservee/20 text-table-reservee',
  occupee: 'bg-table-occupee/20 text-table-occupee',
  verrouillee: 'bg-table-verrouillee/20 text-table-verrouillee',
};

export default function TableInfoCard({
  table,
  onLock,
  onRelease,
  onInstantReservation,
  onTransfer,
  onAssociateToCart,
}: TableInfoCardProps) {
  const badge = STATE_BADGE[table.state] ?? 'bg-gray-500/20 text-gray-300';

  return (
    <div className="card mx-4 mb-4 animate-fade-in">
      {/* Header */}
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-base font-semibold text-white">
          {table.name || table.id}
        </h3>
        <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${badge}`}>
          {STATE_LABELS[table.state] ?? table.state}
        </span>
      </div>

      {/* Info */}
      <div className="text-sm text-gray-400 space-y-1 mb-4">
        <p>Capacite: {table.capacity} personnes</p>
        {table.reservation_id && <p>Reservation: #{table.reservation_id}</p>}
        {table.locked_by && <p>Verrouille par: {table.locked_by}</p>}
      </div>

      {/* Actions based on state */}
      <div className="flex gap-2 flex-wrap">
        {table.state === 'libre' && (
          <>
            {onAssociateToCart && (
              <button type="button" onClick={onAssociateToCart} className="btn-primary text-xs py-1.5 px-3">
                Associer au panier
              </button>
            )}
            <button type="button" onClick={onLock} className="btn-secondary text-xs py-1.5 px-3">
              Verrouiller
            </button>
            <button type="button" onClick={onInstantReservation} className="btn-secondary text-xs py-1.5 px-3">
              Resa minute
            </button>
          </>
        )}
        {table.state === 'reservee' && (
          <button type="button" onClick={onTransfer} className="btn-secondary text-xs py-1.5 px-3">
            Voir reservation
          </button>
        )}
        {table.state === 'occupee' && (
          <button type="button" onClick={onTransfer} className="btn-secondary text-xs py-1.5 px-3">
            Transferer
          </button>
        )}
        {table.state === 'verrouillee' && (
          <button type="button" onClick={onRelease} className="btn-danger text-xs py-1.5 px-3">
            Liberer
          </button>
        )}
      </div>
    </div>
  );
}
